import { classNames } from '@progress/kendo-react-common';
import { CurrencyValue, FlexGrid, FlexGridItemProps, FlexGridLabel, FlexGridProps, FlexGridValue } from 'components';
import styles from './CardGrid.module.scss';

export const CardGrid = ({ children, className }: FlexGridProps) => (
    <FlexGrid className={classNames(styles.grid, className)}>{children}</FlexGrid>
);

export type CardGridAmountProps = {
    value: number
} & FlexGridItemProps;

export const CardGridAmount = ({ value, valueClassName, ...rest }: CardGridAmountProps) => (
    <CardGridItem
        {...rest}
        value={<CurrencyValue value={value} />}
        valueClassName={classNames(styles.amount, valueClassName)}
    />
);

export const CardGridItem = ({ label, labelClassName, value, valueClassName }: FlexGridItemProps) => (
    <>
        <FlexGridLabel className={classNames(styles.label, labelClassName)}>
            {label}
        </FlexGridLabel>
        <FlexGridValue className={classNames(styles.value, valueClassName)}>
            {value}
        </FlexGridValue>
    </>
);
